import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { Ui } from './types'
import { RootState } from '../types'
import { SNACKBAR_TIMEOUT } from '@leapsight/styleguide'

export const state: Ui = {
  snackbar: {
    color: '',
    text: '',
    timeout: SNACKBAR_TIMEOUT
  }
}

const namespaced = true

export const ui: Module<Ui, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
